import { useState, useEffect } from 'react';
import { logError, logInfo } from '@edx/frontend-platform/logging';

import { useModel } from '@src/generic/model-store';
import ElementEventListener from './ElementEventListener';

import { getCookies, handleCorrelationIDCookie, scriptExists } from './utils';

const CohesionWrapper = () => {
  const selectors = [
    '#course-celebration-cert-button',
    '#celebration-footnote-wrapper #upgrade-link',
    '#courseHome-dates #date-verified-upgrade-deadline',
    '#grade-course-header #upgrade-button',
    '#upgrade-shift-dates-alert',
    '#upgrade-complete-alert',
  ];
  const [isLoaded, setLoaded] = useState(false);
  window.chsn_pageType = 'lms-course';
  const courseId = window.location.pathname.split('/')[2];

  const {
    org,
    title,
  } = useModel('courseHomeMeta', courseId);

  const data = {
    tglrCorrelationId: getCookies()?.tglr_correlation_id,
    org: org?.toLowerCase(),
    courseName: title,
  };

  selectors.forEach((selector) => {
    ElementEventListener(selector, 'click', data);
  });

  useEffect(() => {
    if (isLoaded) {
      return;
    }
    const url = 'https://www.edx.org/beam-wrapper.js';
    if (!scriptExists(url)) {
      const head = document.getElementsByTagName('head')[0];
      const script = document.createElement('script');
      script.src = url;
      script.defer = true;
      script.dataset.testId = 'cohesion-test';

      script.onload = () => {
        if (window.tagular && typeof window.tagular === 'function') {
          logInfo('Cohesion script loaded successfully!');
        } else {
          // in the case that the script successfully loaded but tagular is still not found
          logError('window.tagular not found after Cohesion script load.');
        }
      };

      script.onerror = (e) => {
        logError('Cohesion script failed to load', e);
      };

      head.appendChild(script);
      setLoaded(true);
      handleCorrelationIDCookie();
    }
  }, [isLoaded]);

  return null;
};

export default CohesionWrapper;
